import { render, staticRenderFns } from "./inputTel.vue?vue&type=template&id=2a2fae41&scoped=true"
import script from "./inputTel.vue?vue&type=script&lang=js"
export * from "./inputTel.vue?vue&type=script&lang=js"
import style0 from "./inputTel.vue?vue&type=style&index=0&id=2a2fae41&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a2fae41",
  null
  
)

export default component.exports